import { Component } from '@angular/core';
import { PershingTranslationService } from '@pershing/pershing-core';
import { NxiIconService } from '../../services/icon.service';


@Component({
  selector: 'go-paperless',
  templateUrl: './go-paperless.component.html'
})
export class GoPaperlessComponent {
  isLoggedIn: any;
  appSettings: any;
  isEdelEnabled: boolean;
  isDisclosurePage: boolean;

  constructor(
    private translationService: PershingTranslationService,
    private nxiIconService: NxiIconService ) {
      this.translationService.addTranslationFolder('@pershing/nxi-ng-modern-navigation', 'node_modules/@pershing/nxi-ng-modern-navigation/lib');
  }

  redirectRoute(url: string): void {
    document.dispatchEvent(new CustomEvent('portal.gotoview', {
      detail: {
        'gotoPage': url
      }
    }));
  }


  onClick(url: string): void {
    this.nxiIconService.isOneClickEdelEnabled().subscribe(
      response => {
        if (response && response.showOneClickFromGopaperless) {
          document.dispatchEvent(new CustomEvent('portal.oneClickEvent', {
            detail: {
              'goPaperless': response.showOneClickFromGopaperless,
              'suppressOneClickEnrollCancel': response.suppressOneClickEnrollCancel,
              'forceEnrollFlag': response.forceEnrollFlag
            }
          }));
        } else {
          this.redirectRoute(url);
        }
      },
      error => {
        console.log(error);
        this.redirectRoute(url);
      }
    );
  }
}
